import { withSvgIcon } from './withSvgIcon';

export const StatusIcon = withSvgIcon(
  <>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path
      d="M3 12H8.5L10.5 8L13.5 16L15.5 12H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 25' },
);
